import { Box, Typography } from '@mui/material';

type TNoPermissionTextProps = {
  text: string;
  secondaryText?: string;
};
const NoPermissionText = (props: TNoPermissionTextProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {props.text}
      </Typography>
      <Typography color="text.secondary">
        {props.secondaryText
          ? props.secondaryText
          : 'Contact your program admin for more details regarding your user privileges.'}
      </Typography>
    </Box>
  );
};

export default NoPermissionText;
